<template>
  <div class="figure__wrapper" :class="{'figure__wrapper-details': isDetails}">
      <svg :width="defaultSvgParams.width * figureSvgScale"
           :height="defaultSvgParams.height * figureSvgScale"
           :viewBox="`0 0 ${defaultSvgParams.width * figureSvgScale}
           ${defaultSvgParams.height * figureSvgScale}`"
           ref="figure"
           @mouseover="detectCursor()"
           @mouseout="unDetectCursor()"
           :style="{transform: `scale(${zoom})`}">
      <line
        x1="0"
        :y1="changeHeightUp"
        :x2="defaultSvgParams.width"
        :y2="changeHeightUp"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> //ruler horizontal top 2
      <line
        x1="0"
        :y1="changeHeightDown"
        :x2="defaultSvgParams.width"
        :y2="changeHeightDown"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler horizontal bottom 1
      <line
        x1="0"
        :y1="changeHeightDown + changeBias"
        :x2="defaultSvgParams.width"
        :y2="changeHeightDown + changeBias"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler horizontal bottom 2
      <line
        :x1="changeWidthLeft"
        y1="0"
        :x2="changeWidthLeft"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 2
      <line
        :x1="changeWidthRight"
        y1="0"
        :x2="changeWidthRight"
        :y2="defaultSvgParams.height"
        stroke="#D6D6D6" stroke-width="2" stroke-dasharray="5 5"
        v-if="!isNav"></line> // ruler vertical 3
      <path :d="arrowBiasHeight" fill="none" :stroke="isDetails ? arrowsColor : '#F5BB4A'"
        stroke-width="2" style="stroke-linecap: round;" v-if="!isNav"></path> // arrow bias height
      <path :d="arrowWidth" fill="none" :stroke="isDetails ? arrowsColor : '#C6B4FB'"
        stroke-width="2" style="stroke-linecap: round;"
        v-if="!isNav"></path> // arrow width
      <path :d="arrowDirection" fill="none" :stroke="arrowStrokeColor"
            :stroke-width="strokeWidth" style="stroke-linecap: round;"
            :transform="`rotate(${arrowDirectionRotationDegree}
            ${arrowLength - arrowBias} ${arrowDirectionY})`"
            v-if="!isDetails"></path> // arrow Direction
      <defs v-if="isPlate">
        <clipPath id="figureMask">
          <path :d="figureMask" fill="none" :stroke="figureStrokeColor"
           :stroke-width="strokeWidth"
            style="stroke-linecap: round;"></path> // figure mask
        </clipPath>
      </defs>
      <text :x="`${(this.defaultSvgParams.width * this.figureSvgScale) / 2}`"
            :y="changeHeightDown + changeBias + 20" fill="#333333"
            text-anchor="middle" v-if="isDetails">{{ slopeParams.width }} m</text>
      <text :x="`${changeWidthRight + 20}`"
            :y="changeHeightDown + (changeBias / 2)" fill="#333333"
            :transform="`rotate(-90 ${changeWidthRight + 20}
            ${changeHeightDown + (changeBias / 2)})`"
            text-anchor="middle" v-if="isDetails">{{ slopeParams.bias1 }} m</text>
      <g v-if="isDetails" clip-path="url(#figureMask)"> <!--clip-path="url(#figureTopMask)"-->
          <g :transform="`rotate(-${platesRotationDegree}
              ${changeWidthRight} ${changeHeightDown})`">
            <g v-for="i in rowsCount" :key="i" class="row__overlay">
              <rect :x="changeWidthRight - (plateWidth * (i))"
                    :y="i % 2 === 0 ? ((changeHeightDown + changeBias + shiftToPlate) - rowHeight)
                    - (plateHeight / 2)
                    : (changeHeightDown + changeBias + shiftToPlate) - rowHeight"
                    :width="plateWidth - 1"
                    :height="i % 2 === 0 ? rowHeight + plateHeight : rowHeight"
                    fill="#F6F6F6" stroke="#999999"
                    stroke-width="1"
                    @mouseover="showRowInfo(i)"
                    @mouseout="hideRowInfo()"
                    ></rect>
              <line :x1="changeWidthRight - (plateWidth * (i))"
                    :y1="i % 2 === 0 ? ((changeHeightDown + changeBias + shiftToPlate) - rowHeight)
                    + (plateHeight * n) - plateHeight / 2
                    : ((changeHeightDown + changeBias + shiftToPlate) - rowHeight)
                    + (plateHeight * n)"
                    :x2="changeWidthRight - (plateWidth * (i)) + plateWidth - 1"
                    :y2="i % 2 === 0 ? ((changeHeightDown + changeBias + shiftToPlate) - rowHeight)
                    + (plateHeight * n) - plateHeight / 2
                    : ((changeHeightDown + changeBias + shiftToPlate) - rowHeight)
                    + (plateHeight * n)"
                    stroke="#999999"
                    stroke-width="1"
                    v-for="n in i % 2 === 0 ? (itemPerRow) : (itemPerRow - 1)" :key="n"></line>
                    <!--(plateHeight * n + (plateHeight / 2)) + shift-->
            </g>
          </g>
        </g>
      <path :d="rectangularTrapezoidHorizontal" fill="none" :stroke="figureStrokeColor"
            :stroke-width="strokeWidth" style="stroke-linecap: round;"></path>
            // rectangular trapezoid horizontal
      <!--<line
        :x1="changeWidthLeft"
        :y1="changeHeightUp"
        :x2="changeWidthLeft"
        :y2="changeHeightDown"
        stroke="red" stroke-width="4" style="stroke-linecap: round;" /> // left side
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightUp"
        :x2="changeWidthRight"
        :y2="changeHeightDown"
        stroke="blue" stroke-width="4" style="stroke-linecap: round;" /> // top side
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightDown + changeBias"
        :x2="changeWidthRight"
        :y2="changeHeightDown + changeBias"
        stroke="brown" stroke-width="4" style="stroke-linecap: round;"/> // bottom side
      <line
        :x1="changeWidthLeft"
        :y1="changeHeightDown"
        :x2="changeWidthLeft"
        :y2="changeHeightDown + changeBias"
        stroke="lime" stroke-width="4" style="stroke-linecap: round;"/> // bias left
      <line
        :x1="changeWidthRight"
        :y1="changeHeightDown"
        :x2="changeWidthRight"
        :y2="changeHeightDown + changeBias"
        stroke="violet" stroke-width="4" style="stroke-linecap: round;"/> // bias right-->
    </svg>
      <!--<div class="data" v-if="!isNav">
        <h1>coef: {{ scale }}</h1>
        <h1>scaleH: {{ scaleH }}</h1>
        <h1>scaleW: {{ scaleW }}</h1>
        <h1>{{ changeWidthLeft }}</h1>
        <h1>{{ shiftToPlate }}</h1>
        <h1>{{ changeBias }}</h1>
        <h1>{{ plateHeight }}</h1>
      </div>-->
    <MyPopover
      :rowId = "rowId"
      :layersCount = "slopeFromState.slopeLayersCount"
      :plateHeight = "slopeFromState.materialSize.height"
      :plateWidth = "slopeFromState.materialSize.width"
      :windowWidth = "windowWidth"
      :materialAngle = "materialAngle"
      :fixtureCalculationThickness = "fixtureCalculationThickness"
      :backEndRowsCount="backEndRowsCount"
      :masonryType="masonryType"
      :hKr="hKr"
      :qKr="qKr"
      :y1="y1"
      :y2="y2"
      :mouseLeft = "mouseLeft"
      :mouseTop = "mouseTop"
    />
  </div>
</template>

<script>

import MyPopover from '../MyPopover.vue';

export default {
  props: {
    isNav: Boolean,
    defaultSvgParams: Object,
    isDetails: Boolean,
    isPlate: Boolean,
    navId: Number,
    zoom: Number,
    materialAngle: Number,
    fixtureCalculationThickness: Number,
    backEndRowsCount: Number,
    masonryType: String,
    hKr: Number,
    qKr: Number,
    y1: Number,
    y2: Number,
  },
  components: {
    MyPopover,
  },
  data() {
    return {
      rowId: 0,
      mouseTop: null,
      mouseLeft: null,
      windowWidth: null,
    };
  },
  watch: {
  },
  methods: {
    showRowInfo(i) {
      this.rowId = i;
    },
    hideRowInfo() {
      this.rowId = 0;
    },
    getCursorPosition(e) {
      this.mouseTop = e.clientY;
      this.mouseLeft = e.clientX;
    },
    detectCursor() {
      document.addEventListener('mousemove', this.getCursorPosition);
      this.windowWidth = window.innerWidth;
    },
    unDetectCursor() {
      document.removeEventListener('mousemove', this.getCursorPosition);
    },
  },
  computed: {
    slopeFromState() {
      return (!this.isNav && !this.isDetails) || (this.isDetails && this.isPlate)
        ? this.$store.getters.getSlope(this.slopeId)
        : this.$store.getters.getSlope(this.navId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    slopeParams() {
      return this.slopeFromState.slopeParams[0];
    },
    halfPlate() {
      return (this.columnsCount % 2 === 0)
        ? 0 : (((this.slopeFromState.materialSize.height / 1000) / 2) * this.scale);
    },
    rowsCount() {
      return Math.ceil((((this.slopeFromState.slopeParams[0].width
                         / this.slopeFromState.slopeParams[0].ratio)
                         + this.slopeFromState.slopeParams[0].bias1) * 1000)
                       / this.slopeFromState.materialSize.width);
    },
    itemPerRow() {
      return Math.ceil((Math.sqrt((this.newCathetHeight ** 2)
                                  + (this.newCathetWidth ** 2)) * this.scale)
                       / ((this.slopeFromState.materialSize.height / 1000) * this.scale));
    },
    newCathetHeight() {
      return (this.slopeFromState.slopeParams[0].width / this.slopeFromState.slopeParams[0].ratio)
        + this.slopeFromState.slopeParams[0].bias1;
    },
    newCathetWidth() {
      return this.newCathetHeight * this.slopeFromState.slopeParams[0].ratio;
    },
    shiftToPlate() {
      return (Math.ceil(((this.slopeFromState.slopeParams[0].bias1 * this.scale)
                         / this.plateHeight)) - ((this.slopeFromState.slopeParams[0].bias1
                                                  * this.scale) / this.plateHeight))
        * this.plateHeight;
    },
    plateHeight() {
      return (this.slopeFromState.materialSize.height / 1000) * this.scale;
    },
    plateWidth() {
      return (this.slopeFromState.materialSize.width / 1000) * this.scale;
    },
    rowHeight() {
      return this.itemPerRow * this.plateHeight;
    },
    platesRotationDegree() { // высчитываем угол поворота
      return 90 - ((Math.atan(1 / this.slopeParams.ratio)) * 180 / Math.PI);
    },
    arrowStrokeColor() {
      return this.isNav ? '#C8C8C8' : '#999999';
    },
    figureStrokeColor() {
      return this.isNav || this.isDetails ? '#959595' : '#333333';
    },
    strokeWidth() {
      return this.isNav || this.isDetails ? 2 : 4;
    },
    arrowsColor() {
      return '#999999';
    },
    figureSvgScale() {
      return this.isNav ? this.defaultSvgParams.navScale : 1;
    },
    arrowDirectionSize() {
      return this.isNav ? 5 : 10;
    },
    arrowWidth() {
      return `M${this.changeWidthLeft},${this.changeHeightDown + this.changeBias + 30}
      L${this.changeWidthRight},${this.changeHeightDown + this.changeBias + 30}
      M${this.changeWidthLeft + 6},${this.changeHeightDown + this.changeBias + 25}
      L${this.changeWidthLeft},${this.changeHeightDown + this.changeBias + 30}
      M${this.changeWidthLeft + 6},${this.changeHeightDown + this.changeBias + 35}
      L${this.changeWidthLeft},${this.changeHeightDown + this.changeBias + 30}
      M${this.changeWidthRight - 6},${this.changeHeightDown + this.changeBias + 25}
      L${this.changeWidthRight},${this.changeHeightDown + this.changeBias + 30}
      M${this.changeWidthRight - 6},${this.changeHeightDown + this.changeBias + 35}
      L${this.changeWidthRight},${this.changeHeightDown + this.changeBias + 30}`;
    },
    arrowDirection() {
      return `M${this.arrowDirectionStartX},${this.arrowDirectionY}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}
      M${this.arrowDirectionEndX - this.arrowDirectionSize},${this.arrowDirectionY - this.arrowDirectionSize}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}
      M${this.arrowDirectionEndX - this.arrowDirectionSize},${this.arrowDirectionY + this.arrowDirectionSize}
      L${this.arrowDirectionEndX},${this.arrowDirectionY}`;
    },
    rectangularTrapezoidHorizontal() {
      return `M${this.changeWidthLeft},${this.changeHeightUp}
      L${this.changeWidthRight},${this.changeHeightDown}
      M${this.changeWidthRight},${this.changeHeightDown}
      L${this.changeWidthRight},${this.changeHeightDown + this.changeBias}
      M${this.changeWidthRight},${this.changeHeightDown + this.changeBias}
      L${this.changeWidthLeft},${this.changeHeightDown + this.changeBias}
      M${this.changeWidthLeft},${this.changeHeightDown + this.changeBias}
      L${this.changeWidthLeft},${this.changeHeightDown}
      M${this.changeWidthLeft},${this.changeHeightDown}
      L${this.changeWidthLeft},${this.changeHeightUp}
      M${this.changeWidthLeft},${this.changeHeightUp}`;
    },
    arrowBiasHeight() {
      return `M${this.changeWidthRight + 30},${this.changeHeightDown}
      L${this.changeWidthRight + 30},${this.changeHeightDown + this.changeBias}
      M${this.changeWidthRight + 25},${this.changeHeightDown + this.changeBias - 6}
      L${this.changeWidthRight + 30},${this.changeHeightDown + this.changeBias}
      M${this.changeWidthRight + 35},${this.changeHeightDown + this.changeBias - 6}
      L${this.changeWidthRight + 30},${this.changeHeightDown + this.changeBias}
      M${this.changeWidthRight + 25},${this.changeHeightDown + 6}
      L${this.changeWidthRight + 30},${this.changeHeightDown}
      M${this.changeWidthRight + 35},${this.changeHeightDown + 6}
      L${this.changeWidthRight + 30},${this.changeHeightDown}`;
    },
    figureMask() {
      return `M${this.changeWidthLeft},${this.changeHeightUp}
      L${this.changeWidthRight},${this.changeHeightDown}
      L${this.changeWidthRight},${this.changeHeightDown + this.changeBias}
      L${this.changeWidthLeft},${this.changeHeightDown + this.changeBias}
      L${this.changeWidthLeft},${this.changeHeightDown} Z`;
    },
    scaleH() { // коэффициент высоты
      return ((this.defaultSvgParams.baseHeight * this.figureSvgScale) * 100)
      / ((this.slopeParams.width / this.slopeParams.ratio) + this.slopeParams.bias1);
    },
    scaleW() { // коэффициент ширины
      return ((this.defaultSvgParams.baseWidth * this.figureSvgScale) * 100)
      / this.slopeParams.width;
    },
    scale() { // применяемый коэффициент в зависимости от того какой из коэффициентов больше
      return (this.scaleW > this.scaleH) ? this.scaleH : this.scaleW;
    },
    changeWidthLeft() { // изменяем ширину влево
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              - ((this.slopeParams.width * this.scale) / 2));
    },
    changeWidthRight() { // изменяем ширину вправо
      return (((this.defaultSvgParams.width * this.figureSvgScale) / 2)
              + ((this.slopeParams.width * this.scale) / 2));
    },
    changeHeightUp() { // изменяем высоту вверх
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              - ((((this.slopeParams.width / this.slopeParams.ratio)
                   + this.slopeParams.bias1) * this.scale) / 2));
    },
    changeHeightDown() { // изменяем высоту вниз
      return (((this.defaultSvgParams.height * this.figureSvgScale) / 2)
              + ((((this.slopeParams.width / this.slopeParams.ratio)
                   - this.slopeParams.bias1) * this.scale) / 2));
    },
    changeBias() {
      return this.slopeParams.bias1 * this.scale;
    },
    arrowDirectionStartX() { // изменяем ширину направляющей стрелки влево
      return this.arrowLength - this.arrowBias + (this.arrowNewLength * 0.2);
    },
    arrowDirectionEndX() { // изменяем ширину напрвляющей стрелки вправо
      return (this.arrowLength - this.arrowBias)
        + this.arrowNewLength - (this.arrowNewLength) * 0.2;
    },
    arrowDirectionY() { // изменяем положение напрвляющей стрелки по высоте
      return this.changeHeightDown;
    },
    arrowLength() {
      return (this.changeWidthLeft)
        + ((this.slopeParams.width * this.scale) / (this.slopeParams.ratio + 1));
    },
    arrowG() {
      return (this.arrowLength * Math.sqrt(2)) - 20;
    },
    arrowNewLength() {
      return (Math.sqrt((this.arrowLength ** 2) + ((this.arrowBias) ** 2))) - this.changeWidthLeft;
    },
    arrowBias() {
      return (((this.slopeParams.width * this.scale) / (this.slopeParams.ratio + 1))
              / this.slopeParams.ratio);
    },
    arrowDirectionRotationDegree() { // высчитываем угол поворота направляющей
      // стрелки что бы она была перпендикулярна гипотенузе
      return (((Math.atan(1 / this.slopeParams.ratio)) * 180 / Math.PI) - 90);
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
</style>
